import clsx from 'clsx';

// Helpers
import useI18n from '@i18n';
import { IMetaProps } from '../inrefaces';
import { getCurrentStatusElement, getFormatedDate } from '../../utils';

const DialogMetaDesktop: React.FC<IMetaProps> = ({
    date,
    lastFromSupport,
    isReaded,
    className,
}) => {
    const { t } = useI18n('Support');

    return (
        <div className={clsx('text-right', className)}>
            <div className="mb-1 font-normal text-blueGray-500 text-[14px]">
                {getFormatedDate(date)}
            </div>

            {getCurrentStatusElement(isReaded, lastFromSupport, t)}
        </div>
    );
};

export default DialogMetaDesktop;
